import { configureStore, type Reducer } from '@reduxjs/toolkit'
import { sessionReducer, type SessionState } from '@/platform/session/sessionSlice'
import { productsReducer, type ProductsState } from '@/features/catalogs/products/store/productsSlice'
import { taxonomiesReducer, type TaxonomiesState } from '@/features/catalogs/taxonomies/store/taxonomiesSlice'
import { catalogSnapshotReducer, type CatalogSnapshotState } from '@/features/catalogs/shared/catalogSnapshotSlice'
import { createReducerManager } from './reducerManager'

interface RootState {
  session: SessionState
  catalogProducts: ProductsState
  catalogTaxonomies: TaxonomiesState
  catalogSnapshot: CatalogSnapshotState
}

const reducerManager = createReducerManager<RootState>({
  session: sessionReducer,
  catalogProducts: productsReducer,
  catalogTaxonomies: taxonomiesReducer,
  catalogSnapshot: catalogSnapshotReducer,
})
export const store = configureStore({ reducer: reducerManager.reduce })

export function injectReducer(key: string, reducer: Reducer): void {
  if (reducerManager.add(key, reducer)) store.replaceReducer(reducerManager.reduce)
}

export type AppState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
